<script setup lang="ts">
import GozyntaLogo from "@/components/GozyntaLogo.vue";
</script>

<template>
  <p class="creds">
    Powered by
    <a href="https://www.gozynta.com" target="_blank"><GozyntaLogo :height="15" /></a>
  </p>
</template>

<style lang="scss" scoped>
.creds {
  display: flex;
  justify-content: center;
  align-items: end;
  gap: 5px;
  font-size: .875rem;
  padding: 50px 15px 30px;
  text-align: center;
  margin: 0;
  color: map.get(v.$gray, "500");
  a {
    line-height: 0;
    color: inherit;
  }
}
</style>